import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/inputs/ActiveControl';
import useProductService from '../../../app/services/hooks/useProductService';

interface Props {
    productId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const ProductSwitchChange = ({ productId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { activeProduct, fetchingActiveProduct } = useProductService();

    const active = (value: boolean) => {
        setChecked(value);

        activeProduct(productId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={productId} callback={active} />;
};

export default ProductSwitchChange;
